import AlertEventLog from '../../views/alarm/AlertEventLog';

export default [
  {
    path: '/alarm/log',
    name: 'alarm/log',
    component: AlertEventLog
  }
];
